export const USER_DESIGNATION = {
    SUPPLIER: 'supplier',
    CONSUMER: 'consumer',
    ADMIN: 'admin',
}
